import * as yup from "yup";

export const acceptInviteSchema = yup.object({
  password: yup
    .string()
    .required("Password is required")
    .min(8, "At least 8 characters")
    .matches(/[A-Z]/, "At least one uppercase letter")
    .matches(/[a-z]/, "At least one lowercase letter")
    .matches(/\d/, "At least one digit")
    .matches(/[^A-Za-z0-9]/, "At least one special character"),
  confirmPassword: yup
    .string()
    .required("Please confirm your password")
    .oneOf([yup.ref("password")], "Passwords do not match"),
});

export const acceptInviteInitialValues = {
  password: "",
  confirmPassword: "",
};
